export default __webpack_public_path__ + "static/einmalig-live-national-c3a56667a015ab38e7a8e57e49792055.jpg";